import { render, staticRenderFns } from "./CommonTabs.vue?vue&type=template&id=59391390"
import script from "./CommonTabs.vue?vue&type=script&lang=js"
export * from "./CommonTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports